// ============================================
// VARIANT FILTERS WITH ACTIVE FILTERS BAR
// ============================================

document.addEventListener('DOMContentLoaded', function() {
  
  // Function to update active filters display
  function updateActiveFilters() {
    const activeFiltersContainer = document.querySelector('.filter-bar__active-filters .active-filters');
    if (!activeFiltersContainer) return;
    
    // Get the clear all button
    const clearAllBtn = activeFiltersContainer.querySelector('.active-filters__clear');
    
    // Remove all existing variant filter tags (but keep native ones)
    document.querySelectorAll('.active-filters__active-filter[data-variant-filter]').forEach(el => el.remove());
    
    // Get all checked variant filters
    const checkedFilters = document.querySelectorAll('input[data-variant-filter]:checked');
    
    // Add each checked filter to active filters bar
    checkedFilters.forEach(checkbox => {
      const option = checkbox.dataset.option;
      const displayValue = checkbox.dataset.display || checkbox.value.split(' - ')[0];
      const paramName = checkbox.dataset.paramName;
      const value = checkbox.value;
      
      // Create filter tag
      const filterTag = document.createElement('a');
      filterTag.href = '#';
      filterTag.className = 'active-filters__active-filter fs-body-75 no-transition';
      filterTag.setAttribute('data-variant-filter', 'true');
      filterTag.setAttribute('data-param', paramName);
      filterTag.setAttribute('data-value', value);
      filterTag.setAttribute('data-option', option);
      filterTag.setAttribute('data-display', displayValue);
      filterTag.innerHTML = `${option}: ${displayValue} <span class="icon-close">✕</span>`;
      
      // Add click handler to remove filter
      filterTag.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Find and uncheck the corresponding checkbox
        const targetCheckbox = document.querySelector(`input[data-variant-filter][data-option="${option}"][value="${value}"]`);
        if (targetCheckbox) {
          targetCheckbox.checked = false;
          
          // Trigger change event to update URL
          const event = new Event('change', { bubbles: true });
          targetCheckbox.dispatchEvent(event);
        }
        
        // Remove this tag
        this.remove();
        
        // Update count badges
        updateFilterGroupCounts();
      });
      
      // Insert before clear all button
      if (clearAllBtn) {
        activeFiltersContainer.insertBefore(filterTag, clearAllBtn);
      } else {
        activeFiltersContainer.appendChild(filterTag);
      }
    });
    
    // Update filter group counts
    updateFilterGroupCounts();
    
    // Show/hide clear filters button based on any active filters
    const anyActiveFilters = document.querySelectorAll('.active-filters__active-filter').length > 0;
    if (clearAllBtn) {
      if (anyActiveFilters) {
        clearAllBtn.style.display = 'inline-block';
      } else {
        clearAllBtn.style.display = 'none';
      }
    }
  }
  
  // Function to update filter group count badges
  function updateFilterGroupCounts() {
    const groups = {};
    
    // Count active filters per group
    document.querySelectorAll('input[data-variant-filter]:checked').forEach(checkbox => {
      const option = checkbox.dataset.option;
      groups[option] = (groups[option] || 0) + 1;
    });
    
    // Update badges for variant filter groups
    document.querySelectorAll('[data-filter-group][data-variant-group]').forEach(group => {
      const option = group.dataset.variantGroup;
      const button = group.querySelector('.filter-group__label');
      const existingBadge = group.querySelector('.filter-group__label-count');
      
      if (groups[option]) {
        // Update or create badge
        if (existingBadge) {
          existingBadge.textContent = groups[option];
          existingBadge.setAttribute('data-group-active-count', groups[option]);
        } else {
          const badge = document.createElement('span');
          badge.className = 'filter-group__label-count';
          badge.setAttribute('data-group-active-count', groups[option]);
          badge.textContent = groups[option];
          button.appendChild(badge);
        }
        
        // Update clear button
        const clearBtn = group.querySelector('.filter-group__reset');
        if (clearBtn) {
          clearBtn.classList.add('active');
        }
        
        // Update header text
        const headerSpan = group.querySelector('.filter-group__values-active-values');
        if (headerSpan) {
          const activeValues = Array.from(document.querySelectorAll(`input[data-variant-filter][data-option="${option}"]:checked`))
            .map(cb => cb.dataset.display || cb.value.split(' - ')[0])
            .join(', ');
          headerSpan.textContent = activeValues || '0 selected';
        }
      } else {
        // Remove badge if no active filters
        if (existingBadge) {
          existingBadge.remove();
        }
        
        // Reset clear button
        const clearBtn = group.querySelector('.filter-group__reset');
        if (clearBtn) {
          clearBtn.classList.remove('active');
        }
        
        // Reset header text
        const headerSpan = group.querySelector('.filter-group__values-active-values');
        if (headerSpan) {
          headerSpan.textContent = '0 selected';
        }
      }
    });
  }
  
  // Handle checkbox changes
  document.querySelectorAll('input[data-variant-filter]').forEach(function(checkbox) {
    checkbox.addEventListener('change', function(e) {
      e.stopPropagation();
      
      const option = this.dataset.option;
      const paramName = this.dataset.paramName;
      const value = this.value;
      const isChecked = this.checked;
      
      // Add/remove active class on parent li
      if (isChecked) {
        this.closest('li').classList.add('active');
      } else {
        this.closest('li').classList.remove('active');
      }
      
      // Update URL and reload
      applyVariantFilter(option, value, isChecked);
    });
  });
  
  // Handle clear buttons for variant filters
  document.addEventListener('click', function(e) {
    // Clear individual filter group
    const clearBtn = e.target.closest('.filter-group__reset[data-variant-reset]');
    if (clearBtn) {
      e.preventDefault();
      e.stopPropagation();
      
      const optionName = clearBtn.dataset.variantReset;
      
      // Uncheck all checkboxes for this option
      document.querySelectorAll(`input[data-variant-filter][data-option="${optionName}"]`).forEach(checkbox => {
        checkbox.checked = false;
        checkbox.closest('li').classList.remove('active');
      });
      
      // Remove from URL and reload
      const urlParams = new URLSearchParams(window.location.search);
      const paramName = `filter.v.option.${optionName.toLowerCase().replace(/ /g, '-')}`;
      urlParams.delete(paramName);
      window.location.search = urlParams.toString();
    }
    
    // Handle clear all filters
    const clearAllBtn = e.target.closest('.active-filters__clear');
    if (clearAllBtn) {
      e.preventDefault();
      
      // Uncheck all variant filter checkboxes
      document.querySelectorAll('input[data-variant-filter]').forEach(checkbox => {
        checkbox.checked = false;
        checkbox.closest('li').classList.remove('active');
      });
      
      // Clear all variant filter params from URL
      const urlParams = new URLSearchParams(window.location.search);
      document.querySelectorAll('input[data-variant-filter]').forEach(checkbox => {
        const option = checkbox.dataset.option;
        const paramName = `filter.v.option.${option.toLowerCase().replace(/ /g, '-')}`;
        urlParams.delete(paramName);
      });
      
      window.location.search = urlParams.toString();
    }
  });
  
  // Initialize on page load
  setTimeout(function() {
    updateActiveFilters();
    
    // Set initial active states based on checked checkboxes
    document.querySelectorAll('input[data-variant-filter]:checked').forEach(checkbox => {
      checkbox.closest('li').classList.add('active');
    });
  }, 500);
});

// Function to apply variant filter (called from checkbox change)
function applyVariantFilter(optionName, value, isChecked) {
  const urlParams = new URLSearchParams(window.location.search);
  const filterKey = `filter.v.option.${optionName.toLowerCase().replace(/ /g, '-')}`;
  
  if (isChecked) {
    urlParams.append(filterKey, value);
  } else {
    const values = urlParams.getAll(filterKey);
    urlParams.delete(filterKey);
    values.forEach(v => {
      if (v !== value) {
        urlParams.append(filterKey, v);
      }
    });
  }
  
  window.location.search = urlParams.toString();
}